import { createEvent, restore } from 'effector-root'

export const resetColor = createEvent<void>()
export const colorChanged = createEvent<string>()
export const $color = restore(colorChanged, '#ffffff').reset(resetColor)
